import React from "react"
import { FlatList, View } from "react-native"
import { useTrustedPartners } from "@/queries/trustedPartners"
import { BFScreen } from "@/components/standard/screen/BFScreen"
import { Body } from "@/components/standard/BFText"
import { TrustedPartnerCard } from "./components/TrustedPartnerCard"
import { BFScreenHeader } from "@/components/standard/screen/BFScreenHeader"

export default function TrustedPartnersScreen({ loanId }: { loanId: string }) {
  const { data: partners, isLoading, error } = useTrustedPartners(loanId)

  return (
    <BFScreen>
      <BFScreenHeader title={"Trusted Partners"} />
      <View className="flex-1 bg-background p-5">
        {isLoading ? (
          <Body className="text-center mt-4">Loading partners...</Body>
        ) : error ? (
          <Body color="error" className="text-center mt-4">
            Failed to load partners
          </Body>
        ) : partners?.length === 0 ? (
          <Body className="text-center mt-4">
            No trusted partners found for this loan
          </Body>
        ) : (
          <FlatList
            data={partners}
            keyExtractor={(item) => item!.id}
            renderItem={({ item }) => <TrustedPartnerCard partner={item!} />}
            contentContainerStyle={{
              paddingTop: 20,
              paddingBottom: 100,
              gap: 16,
            }}
            showsVerticalScrollIndicator={false}
          />
        )}
      </View>
    </BFScreen>
  )
}
